import { render, staticRenderFns } from "./FailedSales.vue?vue&type=template&id=13bf0122&scoped=true"
import script from "./FailedSales.vue?vue&type=script&lang=js"
export * from "./FailedSales.vue?vue&type=script&lang=js"
import style0 from "./FailedSales.vue?vue&type=style&index=0&id=13bf0122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf0122",
  null
  
)

export default component.exports